import React, { useState } from "react";
import Table from "../../Common/Table";
import Pagination from "../../Common/Pagination";
import useAddCombo from "./useAddCombo";
import AddComboForm from "./AddComboFrom";

const AddCombo = () => {
  const {
    columns,
    currentRows,
    totalRows,
    currentPage,
    rowsPerPage,
    handlePageChange,
    handleRowsPerPageChange,
    loading,
  } = useAddCombo();

  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <div className="p-4 flex flex-col">
      <div className="flex justify-between items-center mb-6">
        <h1 className="text-2xl font-bold">Combo Offers</h1>

        <button
          onClick={() => setIsModalOpen(true)}
          className="bg-blueButton text-white text-sm py-[6px] px-4 md:py-2 rounded-md shadow"
        >
          Create New Combo
        </button>
      </div>
      {isModalOpen && (
        <AddComboForm
          isOpen={() => setIsModalOpen(true)}
          onClose={() => setIsModalOpen(false)}
        />
      )}

      {loading ? (
        <div className="flex justify-center items-center my-4">
          <p className="text-green700 font-medium">Loading data...</p>
        </div>
      ) : (
        <div className="my-2 mb-6  text-green  overflow-auto horizontalscroll">
          <Table className="bg-green50" columns={columns} data={currentRows} />
        </div>

      )}
      <Pagination
        currentPage={currentPage}
        rowsPerPage={rowsPerPage}
        totalRows={totalRows}
        onPageChange={handlePageChange}
        onRowsPerPageChange={handleRowsPerPageChange}
      />
    </div>
  );
};

export default AddCombo;
